// Source: app/scripts/services/services.js
Auction.factory('Attachment', ['$resource', function($resource) {
  return $resource('/object/:id', {}, {
    'getAttachmentsByObjectId': {
      method: 'GET',
      isArray: true,
      url: "/data/rest/attachments/:bean/:id"
    },
    'deleteAttachment': {
      method: 'DELETE',
      url: "/data/rest/attachments/:bean/:id"
    }
  });
}]);


Auction.factory('ExternalFunctionsResolver', ['ExternalFunctions',
  function(ExternalFunctions) {
    return {
      get: function(method) {
        if (typeof ExternalFunctions[method] === 'function') {
          return ExternalFunctions[method];
        } else {
          return method;
        }
      }
    };
  }
]);

Auction.factory('ExternalFunctions', ['$resource', '$filter',
  function($resource, $filter) {
    return {
      groupByTypeName: function(item) {
        return item.type.name;
      },
      groupByGroupName: function(item) {
        if (item.group) {
          return item.group.name;
        } else {
          return $filter("translate")('generic.no_group');
        }
      },
      groupByGroupLabel: function(item) {
        if (item.group) {
          return $filter("translate")(item.group.label);
        } else {
          return $filter("translate")('generic.no_group');
        }
      },
      groupByAbsenceType: function(item) {
        return item.absenceType.name;
      }
    };
  }
]);

Auction.factory('Downloader', ['$http', '$filter',
  function($http, $filter) {
    return {
      download: function(url) {
        $http.get(url, {
          responseType: 'arraybuffer'
        }).success(function(response, status, headers) {
          var filename = "test";
          var disposition = headers('Content-Disposition');
          if (disposition && disposition.indexOf('filename') !== -1) {
            var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            var matches = filenameRegex.exec(disposition);
            if (matches != null && matches[1]) filename = matches[1].replace(/['"]/g, '');
          }
          var type = headers('Content-Type');
          var blob = new Blob([response], {
            type: type
          });

          if (typeof window.navigator.msSaveBlob !== 'undefined') {
            // IE workaround for "HTML7007: One or more blob URLs were revoked by closing the blob for which they were created. These URLs will no longer resolve as the data backing the URL has been freed."
            window.navigator.msSaveBlob(blob, filename);
          } else {
            var URL = window.URL || window.webkitURL;
            var downloadUrl = URL.createObjectURL(blob);

            if (filename) {
              // use HTML5 a[download] attribute to specify filename
              var a = document.createElement("a");
              // safari doesn't support this yet
              if (typeof a.download === 'undefined') {
                window.location = downloadUrl;
              } else {
                a.href = downloadUrl;
                a.download = filename;
                document.body.appendChild(a);
                a.click();
              }
            } else {
              window.location = downloadUrl;
            }

            setTimeout(function() {
              URL.revokeObjectURL(downloadUrl);
            }, 100); // cleanup
          }
        });
      }
    }

  }
]);
